/**
 * Slider Progress Navigation Component
 * Updates the navigation dots based on the current slide position
 */

if (!customElements.get('slider-component')) {
  console.warn('SliderComponent not found. slider-progress.js should be loaded after global.js');
}

// Extend the media-gallery component to handle progress navigation updates
document.addEventListener('DOMContentLoaded', function() {
  // Find all slider components with progress navigation
  const sliderComponents = document.querySelectorAll('slider-component');
  
  sliderComponents.forEach(sliderComponent => {
    const progressNav = sliderComponent.querySelector('.slider-progress-navigation');
    if (!progressNav) return;
    
    const progressDots = progressNav.querySelectorAll('.slider-progress-dot');
    if (!progressDots.length) return;
    
    // Check if this is a mobile product gallery with overlay feature
    const isMobileGallery = window.matchMedia('(max-width: 990px)').matches && 
                            sliderComponent.closest('media-gallery');
    
    // Function to update active dot
    const updateActiveDot = (currentPage) => {
      progressDots.forEach((dot, index) => {
        let isActive = false;
        
        if (isMobileGallery) {
          // On mobile gallery: dot index 0 = page 1, dot index 2+ = page 2+
          // (dot index 1 is hidden via CSS)
          if (currentPage === 1 && index === 0) {
            isActive = true;
          } else if (currentPage >= 2 && index === currentPage) {
            isActive = true;
          }
        } else {
          // Normal behavior: dot index matches page - 1
          if (index === currentPage - 1) {
            isActive = true;
          }
        }
        
        if (isActive) {
          dot.classList.add('active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.classList.remove('active');
          dot.setAttribute('aria-selected', 'false');
        }
      });
    };
    
    // Listen for slide changes
    sliderComponent.addEventListener('slideChanged', (event) => {
      if (!event.detail) return;
      const currentPage = event.detail.currentPage;
      updateActiveDot(currentPage);
    });
    
    // Handle dot clicks to navigate to specific slides
    progressDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const slider = sliderComponent.slider;
        if (!slider) return;
        
        const sliderItems = sliderComponent.sliderItemsToShow || sliderComponent.sliderItems;
        
        // On mobile gallery, map dot clicks correctly
        // Dot 0 → slide 1, Dot 2 → slide 2, Dot 3 → slide 3, etc.
        // (Dot 1 is hidden, so skip it)
        let targetIndex;
        if (isMobileGallery) {
          if (index === 0) {
            targetIndex = 1; // First dot goes to second slide (with first as overlay)
          } else if (index >= 2) {
            targetIndex = index; // Other dots map directly
          } else {
            return; // Skip hidden dot at index 1
          }
        } else {
          targetIndex = index;
        }
        
        if (!sliderItems || !sliderItems[targetIndex]) return;
        
        // Calculate scroll position for the selected slide
        const targetSlide = sliderItems[targetIndex];
        const scrollPosition = targetSlide.offsetLeft;
        
        slider.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      });
    });
    
    // Initialize navigation on scroll (for manual scrolling without buttons)
    const slider = sliderComponent.slider;
    if (slider) {
      slider.addEventListener('scroll', () => {
        // Wait a bit for the currentPage to be calculated
        setTimeout(() => {
          if (!sliderComponent.currentPage) return;
          updateActiveDot(sliderComponent.currentPage);
        }, 50);
      });
    }
  });
});

